import { render, staticRenderFns } from "./PricePlans.vue?vue&type=template&id=4de9f4ab&scoped=true"
import script from "./PricePlans.vue?vue&type=script&lang=js"
export * from "./PricePlans.vue?vue&type=script&lang=js"
import style0 from "./PricePlans.vue?vue&type=style&index=0&id=4de9f4ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de9f4ab",
  null
  
)

export default component.exports